/* unplugin-vue-components disabled */import { render } from "./BharatView.vue?vue&type=template&id=e245a48c&scoped=true"
import script from "./BharatView.vue?vue&type=script&lang=js"
export * from "./BharatView.vue?vue&type=script&lang=js"

import "./BharatView.vue?vue&type=style&index=0&id=e245a48c&scoped=true&lang=css"

import exportComponent from "D:\\Git\\ineedShop\\newcashier\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e245a48c"]])

export default __exports__